// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { app } from '../../../../app';
import { Captcha } from '../../../../components/captcha/captcha.model';
import { SpAlert } from '../../../../components/sp-alert/sp-alert.model';
import { u2f } from '../../../../lib/u2f-api';

app.controller('U2fSAMLController', Controller);

/** @ngInject */
function Controller(
    $rootScope,
    $scope,
    $state,
    $timeout,
    HardTokenSamlLoginService,
    UsbSamlLoginHandler,
) {
    const appKey = $state.params.applicationId;
    const rememberMeKey = `saml-username-${appKey}-fido-u2f`;
    $scope.username = localStorage.getItem(rememberMeKey);
    $scope.rememberMe = !!$scope.username;

    $scope.rememberMeChanged = () => {
        if (!$scope.rememberMe) {
            localStorage.removeItem(rememberMeKey);
        }
    };

    $rootScope.authenticationError = false;
    
    const captcha = $scope.captcha = new Captcha({
        isVisible: () => localStorage.getItem('loginAttempts') >= 3
    });

    $scope.login = function () {


        $rootScope.captchaError = false;
        $rootScope.authenticationError = false;
        $rootScope.topLevelMessage = null;
        
        const data = {
            username: $scope.username,
            captchaResponse: captcha.response
        };
        

        HardTokenSamlLoginService.save({appKey}, data, success, error);

        function success(response) {

            if ($scope.rememberMe) {
                localStorage.setItem(rememberMeKey, $scope.username);
            }

            $rootScope.topLevelMessage = new SpAlert('success', 'U2F Login started...');
            $timeout(1000).then(() => {

                $rootScope.showGuide = true;
                u2f.sign(response.authenticateRequests, 
                function(data){
                    
                    console.log(data);
                    if (!data.errorCode) {
                        $rootScope.showGuide = true;
                        u2fLoginFinish(data);
                        return;
                    }

                    $rootScope.showGuide = false;
                    const key = `hard_token_login.messages.error.ERROR_${data.errorCode}`;
                    $rootScope.topLevelMessage = new SpAlert('danger', key);
                }        
                );
            });

        }

        function error(error) {
            $rootScope.showGuide = false;
            if (error.status == 412) {
                const key = 'registration.company.messages.invalid_captcha';
                $rootScope.topLevelMessage = new SpAlert('danger', key);
            } else {
                $rootScope.topLevelMessage = new SpAlert('danger', error.data.message);
            }
            captcha.reset();
        }

        function u2fLoginFinish(data) {
            UsbSamlLoginHandler.login($scope.username, JSON.stringify(data), null, errorCallback);
        }
    };

    // error callback function on login
    var errorCallback = function(response){
        var status = response.status;
        if (status == 412) {
            $rootScope.captchaError = true;
            $rootScope.captchaErrorMsg = 'login.messages.error.invalid_captcha';
        } else {
            $rootScope.authenticationError = true;
        }
        captcha.reset();
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/public/login-web-saml/hard-token-login/u2f-saml-login.controller.js